import { IconButton, Tooltip } from '@elkaso-app/web-design';
import React from 'react';
import { FiClock, FiEdit3, FiEye, FiTrash2 } from 'react-icons/fi';

export interface ActionsCellProps {
  quotaId: number;
  supplierId: number;
  supplierName: string;
  onView: (quotaId: number) => void;
  onEdit: (quotaId: number) => void;
  onDelete: (quotaId: number) => void;
  onViewHistory: (supplierId: number, supplierName: string) => void;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({
  quotaId,
  supplierId,
  supplierName,
  onView,
  onEdit,
  onDelete,
  onViewHistory,
}) => {
  return (
    <div
      style={{
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 0',
        gap: '6px',
      }}>
      <Tooltip label='View details'>
        <IconButton
          aria-label='View details'
          icon={<FiEye />}
          size='sm'
          colorScheme='blue'
          variant='outline'
          onClick={() => onView(quotaId)}
        />
      </Tooltip>
      <Tooltip label='Edit quota'>
        <IconButton
          aria-label='Edit quota'
          icon={<FiEdit3 />}
          size='sm'
          colorScheme='green'
          variant='outline'
          onClick={() => onEdit(quotaId)}
        />
      </Tooltip>
      <Tooltip label='View contact history'>
        <IconButton
          aria-label='View contact history'
          icon={<FiClock />}
          size='sm'
          colorScheme='purple'
          variant='outline'
          onClick={() => onViewHistory(supplierId, supplierName)}
        />
      </Tooltip>
      <Tooltip label='Delete quota'>
        <IconButton
          aria-label='Delete quota'
          icon={<FiTrash2 />}
          size='sm'
          colorScheme='red'
          variant='outline'
          onClick={() => onDelete(quotaId)}
        />
      </Tooltip>
    </div>
  );
};
